import { Component, ElementRef, Injectable, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';
import DOMPurify from 'dompurify';
import { brokerEnvName } from 'src/environments/environment.tst';


@Injectable({
  providedIn: 'root'
})

@Component({
  selector: 'app-completeRegistration',
  templateUrl: './completeRegistration.component.html',
})
export class CompleteRegistrationComponent implements OnInit {

  public showSpinner: Boolean = false;
  constructor(
    private userService: UserService,
    public auth: AuthService,
    private router: Router) {
  }

  ngOnInit() {

    this.auth.user$.subscribe((account) => {

      let brokerFormId = environment['brokerFormId'];
      let GLFormId = environment['GLFormId'];

      //check if broker or groupleader and route accordingly based on link
      let sapURL = DOMPurify.sanitize(sessionStorage.getItem('sapURL') || "");
      let brokerForm = sessionStorage.getItem('brokerNeedsForm');
      let glForm = sessionStorage.getItem('groupleaderNeedsForm');

      //check if account is broker or groupleader
      //check somewhere if url contains SapURl
      if(brokerForm && !account.is_Broker){
        sessionStorage.removeItem('brokerNeedsForm');
        this.auth.loginWithRedirect({
          authorizationParams: {
            formId: brokerFormId
          }
        });
      }
      else if(glForm){
        sessionStorage.removeItem('groupleaderNeedsForm');
        this.auth.loginWithRedirect({
          authorizationParams: {
            formId: GLFormId
          }
        });
      }
      else if (sapURL){
        sessionStorage.removeItem('brokerNeedsForm');
        sessionStorage.removeItem('sapURL');
        window.location.href = sapURL;
      }
      else {
        this.router.navigate(['/not-approved']);
      }

    });




  }
}
